<template>
  <th>
    <input type="checkbox" @change="onChangeInput" :checked="allChecked" :disabled="disabled"/>
  </th>
</template>

<script>
export default {
  props: {
    selectedList: Array,
    sourceList: Array,
  },
  data() {
    return {
      allChecked: false
    }
  },
  watch: {
    sourceList() {
      this.resetSelectedList()
    },
    selectedList(list) {
      this.allChecked = !_.isEmpty(this.sourceList) && list && list.length === this.sourceList.length
    }
  },
  computed: {
    disabled() {
      return !Boolean(this.sourceList && this.sourceList.length)
    }
  },
  methods: {
    resetSelectedList() {
      this.$utils.clearArray(this.selectedList)
    },
    onChangeInput(e) {
      setTimeout(() => { // ie 오류있을수 있음
        if (e.target.checked) {
          this.resetSelectedList()
          _.forEach(this.sourceList, item => this.selectedList.push(item))
        }
        else this.resetSelectedList()
      }, 0)
    }
  }
}
</script>
